export const createRecordingFile = (chunks, recorderType) => {
  const mimeType = recorderType || chunks.find(chunk => chunk.type)?.type || "audio/webm";
  const extensions = {
    "audio/mp4": "m4a",
    "audio/ogg": "ogg",
    "audio/mpeg": "mp3",
    "audio/wav": "wav",
    "audio/webm": "webm",
  };
  const extension = extensions[mimeType.split(";")[0].trim().toLowerCase()] || "webm";
  return new File(chunks, `audio-${Date.now()}.${extension}`, { type: mimeType });
};
